// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7c6396dc","453":"8e57acc6","455":"c38eeea3","977":"b16a2aa9"}[chunkId] + ".chunk.js";
};